(function() {
    'use strict';

    angular.module('dashboardApp').service('Logger', Service);

    Service.$inject = [ ];


    function Service() {

        var debug = true;


        this.log = function (message) {
            if (debug && console) {
                console.log(message);
            }
        };



        this.error = function (message) {
            if (debug && console) {
                console.error(message);
            }
        };




    }

})();
